import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ tag, title, subtitle, center = false }) => (
  <div className={center ? "text-center max-w-2xl mx-auto" : "max-w-3xl"}>
    <Reveal>
      <span className="tag-label">{tag}</span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display font-extrabold text-4xl sm:text-5xl mt-5 leading-[1.02]">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className="text-[#9CA3AF] text-base sm:text-lg mt-5 leading-relaxed">
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
